import { aemImageLoader, parseImageData, PROPERTY_CARD_FALLBACK_IMAGE_URL } from '@greystar/lib';
import { NextImage, ImageFieldValue, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
interface ResponsiveImageProps {
  image?: ImageField | string;
  alt?: string;
  priority?: boolean;
  quality?: number;
  placeholder?: 'empty' | 'blur';
  loading?: 'lazy' | 'eager';
  sizes?: string;
  className?: string;
  style?: React.CSSProperties;
  width?: number;
  height?: number;
  fill?: boolean;
  objectFit?: 'cover' | 'contain';
  fallbackImageSrc?: string;
}

const ResponsiveImage = ({
  image,
  alt = '',
  priority = false,
  quality = 70,
  placeholder = 'empty',
  loading = 'lazy',
  sizes = '100vw',
  className = '',
  style = {},
  width,
  height,
  fill = false,
  objectFit = 'cover',
  fallbackImageSrc = PROPERTY_CARD_FALLBACK_IMAGE_URL,
}: ResponsiveImageProps) => {
  let parsedImage = null;

  if (image && typeof image === 'string') {
    parsedImage = { src: image, alt: alt };
  } else if (typeof image === 'object' && image?.value) {
    parsedImage = parseImageData(image.value as unknown as string) as unknown as ImageFieldValue;
  }

  parsedImage ??= {
    src: fallbackImageSrc,
    alt: alt,
  };

  const imageWidth = parseInt(`${width ?? parsedImage.width ?? ''}`, 10);
  const imageHeight = parseInt(`${height ?? parsedImage.height ?? ''}`, 10);

  const setFallBackImage = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.currentTarget;
    if (target.src.includes(fallbackImageSrc)) return;

    target.onerror = null; // prevents looping
    target.srcset = '';
    target.src = fallbackImageSrc;
  };

  if (fill) {
    return (
      <div
        className={`relative ${className}`}
        style={{
          ...style,
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        <NextImage
          field={parsedImage}
          fill
          style={{ objectFit }}
          priority={priority}
          quality={quality}
          placeholder={placeholder}
          loading={loading}
          loader={aemImageLoader}
          sizes={sizes}
          onError={setFallBackImage}
        />
      </div>
    );
  }

  return (
    <NextImage
      field={parsedImage}
      width={imageWidth}
      height={imageHeight}
      priority={priority}
      quality={quality}
      placeholder={placeholder}
      loading={loading}
      sizes={sizes}
      loader={aemImageLoader}
      className={className}
      onError={setFallBackImage}
    />
  );
};

export default ResponsiveImage;
